import ProductbannerList from './List'
import ProductbannerEdit from './Edit'
import ProductbannerCreate from './Create'

const ProductbannersResource = {
  list: ProductbannerList,
  edit: ProductbannerEdit,
  create: ProductbannerCreate,
}

export default ProductbannersResource
